import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import {Button} from 'antd';
import moment from 'moment';
import LandingSectionHeader from '../../Components/LandingSectionHeader';
import * as AppActions from '../../AppActions';

function Blogs(props) {
  const {blogs} = props;
  const [dimension] = useOutlet('dimension');
  const mobile = dimension.rwd === 'mobile';

  return (
    <Wrapper mobile={mobile}>
      <LandingSectionHeader title="部落格" subtitle="Blog" color="#0eb407" />
      <section
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        {blogs.map((data, i) => (
          <BlogItem key={i} data={data} />
        ))}
      </section>
      <Button
        style={{alignSelf: 'flex-end'}}
        onClick={() => {
          AppActions.navigate('/articles', {loading: true});
        }}>
        <span>More</span>
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin: 0 auto;
  padding: 95px 45px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
`;

export default Blogs;

function BlogItem(props) {
  let {data} = props;

  return (
    <BlogWrapper
      img={data.image}
      onClick={() => {
        AppActions.navigate(`/article?id=${data.id}`, {loading: true});
      }}>
      <div className="bg-img" />
      <div className="content">
        <div className="title">
          <h3>{data.title}</h3>
          <span>{moment(data.created).format('YYYY-MM-DD hh:mm')}</span>
        </div>
        <div className="content">{data.outline}</div>
      </div>
    </BlogWrapper>
  );
}

const BlogWrapper = styled.div`
  margin-bottom: 56px;
  border-radius: 20px;
  max-width: 1300px;
  width: 100%;
  min-height: 285px;
  background-color: #ffffff;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  overflow: hidden;
  display: flex;
  cursor: pointer;
  transition: transform 400ms ease;
  &:hover {
    transform: scale(1.025);
  }

  & > .bg-img {
    max-width: 285px;
    width: 100%;
    background-color: #acacac;

    background-image: url(${(props) => props.img});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  & > .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    padding: 40px 60px;

    & > .title {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      border-bottom: 1px solid var(--primaryColor);
      padding-bottom: 16px;
      width: 100%;
      color: var(--primaryColor);

      & > h3 {
        font-size: ${(props) => (props.mobile ? '20px' : '25px')};
        color: var(--primaryColor);
      }
    }

    & > .content {
      margin: 25px 0px 10px 0px;
      max-width: 1015px;
      width: 100%;
      height: 92px;
      line-height: 1.9;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 500;
      font-size: 16px;
      color: #cecece;
    }

    & > button {
      align-self: flex-end;
      border: 0px;
      background-color: #ffffff;
      font-size: 14px;
      color: var(--primaryColor);
      cursor: pointer;

      :hover {
        border-radius: 10px;
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;

    & > .bg-img {
      max-width: none;
      height: 200px;
    }

    & > .content {
      padding: 20px;

      & > .title {
        & > h3 {
          font-size: 18px;
        }
      }

      & > .content {
        height: 86px;
        font-size: 12px;
      }
    }
  }
`;
